import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const spendTimeseriesResponse = z.array(
  z.object({
    revenue_date_pst: z.string(),
    spend_category: z.string(),
    adj_gross_revenue: z.number(),
  })
)

export type SpendTimeseries = z.infer<typeof spendTimeseriesResponse>

export async function getSpendTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_timeseries', data, { signal })
    .then((response) => response.data)
    .then(spendTimeseriesResponse.parse)
}

export async function getSpendTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_timeseries/csv', data, { signal })
    .then((response) => response.data)
}
